module.exports = __webpack_public_path__ + "img/lost-sign.73370a78.svg";